import {
  Button,
  FormControl,
  FormLabel,
  HStack,
  Input,
  Text,
  useToast,
  VStack,
} from '@chakra-ui/react';
import { Auth, graphqlOperation } from 'aws-amplify';
import { useFormik } from 'formik';
import React, { useState } from 'react';
import { connect } from 'react-redux';
import { createMerchantAccount } from '../../graphql/mutations';
import { graphql } from '../../utils/api';
import { setUser } from '../../utils/auth';

const AddBusinessForm = ({ nextStep, addBussiness }) => {
  const toast = useToast();
  const [submitLoading, setSubmitLoading] = useState(false);

  const formik = useFormik({
    initialValues: {
      companyName: '',
      contactName: '',
      contactPhoneNumber: '',
      contactEmail: '',
    },
    onSubmit: async (values) => {
      try {
        setSubmitLoading(true);
        const { data } = await graphql(
          graphqlOperation(createMerchantAccount, {
            input: {
              companyName: values.companyName,
              contactName: values.contactName,
              contactEmail: values.contactEmail,
              contactPhoneNumber: values.contactPhoneNumber,
              accountStatus: 'NEW',
            },
          }),
        );
        const { createMerchantAccoun: addedMerchant } = data;

        addBussiness(addedMerchant);
        setTimeout(async () => {
          const cognitoUserObj = await Auth.currentAuthenticatedUser();
          setSubmitLoading(false);
          setUser(cognitoUserObj);
          nextStep();
        }, 1000);
      } catch (err) {
        setSubmitLoading(false);
        toast({
          title: 'Error',
          description: 'Something went wrong in creating merchant account',
          status: 'error',
          isClosable: true,
          duration: 5000,
        });
      }
    },
  });

  const { handleChange, handleBlur, values, errors, handleSubmit } = formik;
  return (
    <VStack
      align="flex-start"
      my={4}
      spacing={4}
      as="form"
      onSubmit={(e) => {
        e.preventDefault();
        handleSubmit();
      }}
    >
      <Text fontSize="2xl" fontWeight="700" mt="2">
        Business setup
      </Text>
      <FormControl isRequired isInvalid={!!errors.companyName} id="name">
        <FormLabel>Company Name</FormLabel>
        <Input
          name="companyName"
          onChange={handleChange}
          value={values.companyName}
          onBlur={handleBlur}
        />
      </FormControl>
      <FormControl isRequired isInvalid={!!errors.contactName} id="contactName">
        <FormLabel>Contact Name</FormLabel>
        <Input
          name="contactName"
          onChange={handleChange}
          value={values.contactName}
          onBlur={handleBlur}
        />
      </FormControl>
      <FormControl
        id="contactPhoneNumber"
        isRequired
        isInvalid={!!errors.contactPhoneNumber}
      >
        <FormLabel>Contact Mobile number</FormLabel>
        <Input
          value={values.contactPhoneNumber}
          name="contactPhoneNumber"
          onChange={handleChange}
          onBlur={handleBlur}
        />
      </FormControl>
      <FormControl
        id="contactEmail"
        isRequired
        isInvalid={!!errors.contactEmail}
      >
        <FormLabel>Company Email Id</FormLabel>
        <Input
          name="contactEmail"
          value={values.contactEmail}
          onChange={handleChange}
          onBlur={handleBlur}
        />
      </FormControl>
      <Button
        type="submit"
        mb={3}
        width="full"
        _hover={{ background: 'brand.red' }}
        isLoading={submitLoading}
      >
        Next
      </Button>
      <HStack>
        <Button
          isLoading={submitLoading}
          type="submit"
          mt={3}
          width="min-content"
        >
          Finish
        </Button>
      </HStack>
    </VStack>
  );
};

const stateMapper = () => ({});

const dispatchMapper = (dispatch) => ({
  addBussiness: dispatch.bussiness.addBussiness,
});

export default connect(stateMapper, dispatchMapper)(AddBusinessForm);
